import axios from 'axios';
import { useEffect, useState } from 'react';
import { endPoints } from "../../Constants";
import { Link } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useTranslation,Trans  } from 'react-i18next';
const Events = () => {
    const { t,i18n } = useTranslation();
    const [myEvents, setMyEvents] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('token');

        axios
            .get(`${endPoints.event}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((res) => {
                const limitedEvents = res.data.slice(0, 3);
                setMyEvents(limitedEvents);
            })
            .catch((err) => {
                console.error("Error fetching data:", err);
            });
    }, []);

    // Function to open modal with selected event
    const handleShow = (event) => {
        setSelectedEvent(event);
        setShowModal(true);
    };

    // Function to close modal
    const handleClose = () => setShowModal(false);

    return (
        <>
            <section className='lyt-section typ-event-section' id='evhligt'>
                <div className='container'>
                    <div className='heading-wrapper'>
                        <div>
                            <h2
                                className='bs-heading typwhite mb-2'
                                data-aos="fade-in"
                                data-aos-delay="200"
                            >
                               {t('highlightsTitle')}
                            </h2>
                            <p
                                className='bs-para typwhite'
                                data-aos="fade-in"
                                data-aos-delay="300"
                            >
                                {t('highlightsDesc')}
                            </p>
                        </div>

                        <Link
                            className="bs-btn typfill typdardbg"
                            to="/event-listing"
                            aria-label="Navigate to All Events"
                            data-aos="fade-in"
                            data-aos-delay="200"
                        >
                            {t('viewAll')} <span className="icon icon-right-arrow"></span>
                        </Link>
                    </div>

                    <div className='bs-grid-box'>
                        {myEvents.map((item, index) => {
                            const {
                                eventShortDes = 'No Description Available',
                                eventDate = 'Date Not Available',
                                eventShortDesMr,
                                isOngoing,
                                eventImageURL,
                                readMoreContent,
                            } = item;

                             const EventShortDes = i18n.language === 'mr' ? eventShortDesMr : eventShortDes;
                            return (
                                <div
                                    key={index}
                                    className='bs-card typ-event'
                                    data-aos="fade-in"
                                    data-aos-delay="200"
                                >
                                    <div className='box-img'>
                                        <img
                                            className="img-fluid"
                                            src={eventImageURL || 'https://via.placeholder.com/384x297'}
                                            alt={EventShortDes}
                                            width={384}
                                            height={297}
                                        />
                                    </div>
                                    <div className='set-contentBox'>
                                        {isOngoing === "Yes" && (
                                            <div className='tag'>Ongoing Event</div>
                                        )}
                                        <div className='box-text'>
                                            <div className='title'>{EventShortDes}</div>
                                            <div className='new-flex'>
                                                <div>
                                                    <div className='date'>{eventDate}</div>
                                                </div>
                                                <a
                                                    className="bs-btn typexplore"
                                                    onClick={() => handleShow(item)}
                                                    href='#'
                                                >
                                                   {t('exploreMore')}  <span className="icon icon-right-arrow"></span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

             {/* Modal for Event Details */}
             <Modal show={showModal} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    {/* <Modal.Title>{selectedEvent?.eventShortDes || "Event Details"}</Modal.Title> */}
                </Modal.Header>
                <Modal.Body>
                    {selectedEvent && (
                        
                        <>
                         
                        
                            <img
                                src={selectedEvent.eventImageURL || 'https://via.placeholder.com/500'}
                                alt={i18n.language === 'mr' ? selectedEvent.eventShortDesMr : selectedEvent.eventShortDes}
                                className="img-fluid mb-3 w-100"
                                style={{ maxHeight: '300px', objectFit: 'cover', width: '100%' }}
                            />
                            <p className='bs-para typ-fw400 typ-16'>
                                {i18n.language === 'mr' ? selectedEvent.eventShortDesMr : selectedEvent.eventShortDes || "No further details available."}
                            </p>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {t('close')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default Events;
